module.exports = __webpack_public_path__ + "static/media/26.3e9b02fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/26.jpg
// module id = 201
// module chunks = 0